import React from 'react';
import useTheme from '@hero/branding/theme';

interface StatusBadgeIconProps {
    done: boolean;
    title: string;
}

const CIRCLE_D =
    'M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36Z';
const CHECK_D = 'M12 20.75L16.8696 26L28 14';
const CLOCK_HAND_VERTICAL_D = 'M20 20V11.04';
const CLOCK_HAND_DIAGONAL_D = 'M20 20L26.48 27.42';

const StatusBadgeIcon: React.FC<StatusBadgeIconProps> = ({ done, title }) => {
    const { colors } = useTheme();
    const stroke = done ? colors.status.success.alpha : colors.brand.primary.alpha;
    const paths = done
        ? [CIRCLE_D, CHECK_D]
        : [CLOCK_HAND_VERTICAL_D, CIRCLE_D, CLOCK_HAND_DIAGONAL_D];

    return (
        <span
            title={title}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '4.4rem',
                height: '4.4rem'
            }}
        >
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                {paths.map((d) => (
                    <path
                        key={d}
                        d={d}
                        stroke={stroke}
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                    />
                ))}
            </svg>
        </span>
    );
};

export default StatusBadgeIcon;
